const LOGIN_ORIGIN_KEY = 'loginOrigin';
export const OPENKNOTS_LOGIN_PATH = '/openknots/login';
export const DEFAULT_LOGIN_PATH = '/login';

export const setLoginOrigin = (origin) => {
    try {
        sessionStorage.setItem(LOGIN_ORIGIN_KEY, origin);
    } catch {
        // ignore
    }
};

export const getLogoutLoginPath = () => {
    try {
        if (sessionStorage.getItem(LOGIN_ORIGIN_KEY) === 'openknots') {
            return OPENKNOTS_LOGIN_PATH;
        }
    } catch {
        // ignore
    }
    return DEFAULT_LOGIN_PATH;
};